import React, { useRef } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingBar from 'react-top-loading-bar';
import Admin from './pages/Admin';
import MyNft from './pages/MyNft';
import Home from './pages/Home';
import AllNFTs from './pages/AllNFTs';
import Category from './pages/Category';
import StakedNFTs from './pages/StakedNFTs';

function App() {
  const ref = useRef(null);

  return (
    <div className="App">
      <HashRouter>
        <LoadingBar color="#f0b90b" ref={ref} height={4} />
        <ToastContainer pauseOnFocusLoss={false} />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <Home
                continuousStart={() => ref.current.continuousStart()}
                staticStart={() => ref.current.staticStart()}
                complete={() => ref.current.complete()}
              />
            }
          />
          <Route
            exact
            path="/allnft"
            element={
              <AllNFTs
                continuousStart={() => ref.current.continuousStart()}
                staticStart={() => ref.current.staticStart()}
                complete={() => ref.current.complete()}
              />
            }
          />
          <Route
            exact
            path="/my-nft"
            element={
              <MyNft
                continuousStart={() => ref.current.continuousStart()}
                staticStart={() => ref.current.staticStart()}
                complete={() => ref.current.complete()}
              />
            }
          />
          <Route
            exact
            path="/staked"
            element={
              <StakedNFTs
                continuousStart={() => ref.current.continuousStart()}
                staticStart={() => ref.current.staticStart()}
                complete={() => ref.current.complete()}
              />
            }
          />
          <Route
            exact
            path="/category/:id"
            element={
              <Category
                continuousStart={() => ref.current.continuousStart()}
                staticStart={() => ref.current.staticStart()}
                complete={() => ref.current.complete()}
              />
            }
          />
          <Route exact path="/frontend-admin" element={<Admin />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
